import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const JOB_FUNCTION_CREATE_RESOURCE = "job-function" as const;
export const JOB_FUNCTION_CREATE_API_PATH = `/v1/${JOB_FUNCTION_CREATE_RESOURCE}` as const;

export type JobFunctionCreateBody =
  paths[typeof JOB_FUNCTION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type JobFunctionCreateResponse =
  paths[typeof JOB_FUNCTION_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useJobFunctionCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<JobFunctionCreateResponse, Error, JobFunctionCreateBody>({
    mutationFn: async (jobFunction: JobFunctionCreateBody) => {
      const response = await alphartisApiAxios.post<JobFunctionCreateResponse>(
        JOB_FUNCTION_CREATE_API_PATH,
        jobFunction,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [JOB_FUNCTION_CREATE_RESOURCE],
      });
    },
  });
};
